import store from "@/store/store";
import BeCuponUtils from "@/utils/Utils";

export default class Coupon {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        couponRetrieve(id: ${id}) {
          isActive
          affiliate
          available
          amountCompleted
          amountActives
          id
          title
          showApp
          subTitle
          description
          smallDescription
          expirationDate
          globalTotalUses
          globalUses
          assignedCoupon
          globalActives
          inWallet
          images {
            id
            url
          }
          initialDate
          dailyUses
          totalUses
          maxPerson
          valuedAt
          coupons {
            id
            title
          }
          branchOffices {
            id
            name
          }
          company{
            id
            name
          }
          hideAuto
          datetimeHideAutoStart
          datetimeHideAutoOff 
          qrText
          qrValidationCode
          qrValidationCodeUses
          totalClick
          qrBarcode {
            id
            url
          }      
          deal {
            id
            name
            description
          }
          subCategory {
            id
            name
            desc
          }          
          clientType {
            id
            name
            desc
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    if(response.data.data.couponRetrieve.hideAuto) {
       response.data.data.couponRetrieve.datetimeHideAutoDateStart = response.data.data.couponRetrieve.datetimeHideAutoStart.split('T')[0];
       response.data.data.couponRetrieve.datetimeHideAutoTimeStart = response.data.data.couponRetrieve.datetimeHideAutoStart.split('T')[1].substr(0,5);

       response.data.data.couponRetrieve.datetimeHideAutoDateOff = response.data.data.couponRetrieve.datetimeHideAutoOff.split('T')[0];
       response.data.data.couponRetrieve.datetimeHideAutoTimeOff = response.data.data.couponRetrieve.datetimeHideAutoOff.split('T')[1].substr(0,5);
    }

    if(BeCuponUtils.isManager(store.state.currentUser) !== -1 || !BeCuponUtils.isAdmin(store.state.currentUser)) {
       if(response.data.data.couponRetrieve.coupons !== null) response.data.data.couponRetrieve.coupons.maximumSales = "N/A";
    }

    response.data.data.couponRetrieve.compressed = {
      coupons: response.data.data.couponRetrieve.coupons,
      deal: response.data.data.couponRetrieve.deal,
      subCategory: response.data.data.couponRetrieve.subCategory.map(node => node),
      clientType: response.data.data.couponRetrieve.clientType,
      branchOffices: response.data.data.couponRetrieve.branchOffices.map(node => node),
      company: response.data.data.couponRetrieve.company
    };

    response.data.data.couponRetrieve.coupons = response.data.data.couponRetrieve.coupons !== null ? response.data.data.couponRetrieve.coupons.id : null;
    response.data.data.couponRetrieve.deal = response.data.data.couponRetrieve.deal.id;

    response.data.data.couponRetrieve.qrValidationCodeUses = response.data.data.couponRetrieve.qrValidationCodeUses !== null ? response.data.data.couponRetrieve.qrValidationCodeUses : "N/A";
    response.data.data.couponRetrieve.totalClick = response.data.data.couponRetrieve.totalClick !== null ? response.data.data.couponRetrieve.totalClick : "N/A";

    response.data.data.couponRetrieve.subCategory = response.data.data.couponRetrieve.subCategory.map(node => node.id);
    response.data.data.couponRetrieve.clientType = response.data.data.couponRetrieve.clientType.map(clientType => clientType.id);
    response.data.data.couponRetrieve.branchOffices = response.data.data.couponRetrieve.branchOffices.map(node => node.id);

    response.data.data.couponRetrieve.validation = true;

    return response.data.data.couponRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        couponList(affiliate:${payload.affiliate}){
          results{
            id
            affiliate
            isActive
            available
            amountCompleted
            amountActives
            title
            expirationDate
            globalTotalUses
            globalUses
            globalActives
            totalUses
            showApp
            inWallet
            assignedCoupon
            company{
              id
              name
            }
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            qrText
            qrValidationCode 
            qrValidationCodeUses 
            totalClick
            qrBarcode {
              id
              url
            }            
            coupons {
              id
              title
              maximumSales
            }
            branchOffices{
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(let i=0; i < response.data.data.couponList.results.length; i++) {
      if(response.data.data.couponList.results[i].coupons !== null) {
          response.data.data.couponList.results[i].globalUses = response.data.data.couponList.results[i].totalUses * response.data.data.couponList.results[i].coupons.maximumSales;
      }
      if(BeCuponUtils.isManager(store.state.currentUser) !== -1 || !BeCuponUtils.isAdmin(store.state.currentUser)) {
         if(response.data.data.couponList.results[i].coupons !== null) response.data.data.couponList.results[i].coupons.maximumSales = "N/A";
      }
      response.data.data.couponList.results[i].qrValidationCodeUses = response.data.data.couponList.results[i].qrValidationCodeUses !== null ? response.data.data.couponList.results[i].qrValidationCodeUses : "N/A";
      response.data.data.couponList.results[i].totalClick = response.data.data.couponList.results[i].totalClick !== null ? response.data.data.couponList.results[i].totalClick : "N/A";
    }

    return response.data.data.couponList.results.reverse();
  }

  static async allOfCoupons(axios, active, coupons) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponList (active: ${active}, coupons: ${coupons}){
          results{
            id
            isActive
            available
            amountCompleted
            amountActives
            title
            expirationDate
            globalTotalUses
            globalUses
            globalActives
            images {
              id
              url
            }
            company{
              id
              name
            }
            initialDate
            dailyUses
            totalUses
            qrText
            qrValidationCode  
            qrValidationCodeUses
            totalClick
            qrBarcode {
              id
              url
            }            
            coupons{
              id
              title
            }
            branchOffices{
              id
              name
            }
            couponsUses{
              id
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponList.results.reverse();
  }

  static async allOfBranchOffice(axios, active, branchOffice) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponList (active: ${active}, branchOffices: ${branchOffice}){
          results{
            id
            isActive
            available
            amountCompleted
            amountActives
            title
            expirationDate
            globalTotalUses
            globalUses
            globalActives
            images {
              id
              url
            }
            initialDate
            company{
              id
              name
            }
            dailyUses
            totalUses
            qrText
            qrValidationCode 
            qrValidationCodeUses 
            totalClick
            qrBarcode {
              id
              url
            }            
            coupons{
              id
              title
            }
            branchOffices{
              id
              name
            }
            couponsUses{
              id
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponList.results.reverse();
  }

  static async allOfCompany(axios, active, company) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponCompany (active:${active}, companyId: ${company}) {
          id
          isActive
          available
          amountCompleted
          amountActives
          title
          expirationDate
          globalTotalUses
          globalUses
          globalActives
          images {
            id
            url
          }
          company{
            id
            name
          }
          assignedCoupon
          initialDate
          dailyUses
          totalUses
          qrText
          qrValidationCode  
          qrValidationCodeUses
          totalClick
          qrBarcode {
            id
            url
          }          
          coupons{
            id
            title
          }
          branchOffices{
            id
            name
          }
          couponsUses{
            id
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponCompany;
  }

  static async filter(axios, active) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponList (active: ${active}){
          results{
            id
            isActive
            available
            amountCompleted
            amountActives
            title
            expirationDate
            globalTotalUses
            globalUses
            inWallet
            globalActives
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            showApp
            assignedCoupon
            qrText
            company{
              id
              name
            }
            qrValidationCode
            qrValidationCodeUses  
            totalClick
            qrBarcode {
              id
              url
            }            
            coupons{
              id
              title
            }
            branchOffices{
              id
              name
            }
            couponsUses{
              id
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteCoupon ($id: ID!){
          deleteCoupon(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteCoupon.ok;
  }

  static async create(axios, title, subTitle, description, smallDescription, initialDate, expirationDate,
                      dailyUses, totalUses, maxPerson, valuedAt, company, coupons, images, branchOffices, hideAuto, datetimeHideAutoStart,
                      datetimeHideAutoOff, deal, subCategory, clientType, showApp, assignedCoupon, affiliate
               )
  {
    const couponsField = (coupons > 0) ? `coupons: ${coupons},` : ``;
    const imageField = (images !== -1) ? `images: [${images}],` : ``;
    const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");
    const desc = (newDescrip !== null) ? `description: "${newDescrip}",` : ``;
    const datetimeStart = datetimeHideAutoStart !== null ? `datetimeHideAutoStart: "${datetimeHideAutoStart}",` : ``;
    const datetimeOff = datetimeHideAutoOff !== null ? `datetimeHideAutoOff: "${datetimeHideAutoOff}",` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation {
        createCoupon(newCoupon:{
          ${couponsField}
          ${imageField}
          ${desc}
          smallDescription: "${smallDescription}",
          title: "${title}",
          subTitle: "${subTitle}",
          initialDate: "${initialDate}",
          expirationDate: "${expirationDate}",
          dailyUses: ${dailyUses},
          totalUses: ${totalUses},
          maxPerson: ${maxPerson},
          valuedAt: ${valuedAt},
          branchOffices: ${branchOffices},          
          hideAuto: ${hideAuto},
          ${datetimeStart}
          ${datetimeOff}
          deal: ${deal},
          company: ${company},
          subCategory: ${subCategory},
          clientType: ${clientType},
          showApp: ${showApp},
          assignedCoupon: ${assignedCoupon},      
          affiliate: ${affiliate},      
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.createCoupon.ok;
  }

  static async edit(axios, id, title, subTitle, description, smallDescription, initialDate, expirationDate,
                    dailyUses, totalUses, maxPerson, valuedAt, coupons, images, branchOffices, hideAuto,
                    datetimeHideAutoStart, datetimeHideAutoOff, deal, subCategory, clientType, showApp, company,
                    assignedCoupon, affiliate
  )
  {
    const couponsField = (coupons > 0) ? `coupons: ${coupons},` : ``;
    const imageField = (images !== -1) ? `images: [${images}],` : ``;
    const desc = (description !== null) ? `description: "${description}",` : ``;
    const datetimeStart = datetimeHideAutoStart !== null ? `datetimeHideAutoStart: "${datetimeHideAutoStart}",` : ``;
    const datetimeOff = datetimeHideAutoOff !== null ? `datetimeHideAutoOff: "${datetimeHideAutoOff}",` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCoupon(newCoupon:{
          ${couponsField}
          ${imageField}
          ${desc}          
          id: "${id}",
          smallDescription: "${smallDescription}",
          title: "${title}",
          subTitle: "${subTitle}",
          initialDate: "${initialDate}",
          expirationDate: "${expirationDate}",
          dailyUses: ${dailyUses},
          totalUses: ${totalUses},
          maxPerson: ${maxPerson},
          valuedAt: ${valuedAt},
          branchOffices: ${branchOffices},          
          hideAuto: ${hideAuto},
          ${datetimeStart}
          ${datetimeOff}
          deal: ${deal},
          subCategory: ${subCategory},
          clientType: ${clientType},
          showApp: ${showApp},
          company: ${company},
          assignedCoupon: ${assignedCoupon}  
          affiliate: ${affiliate}  
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCoupon.ok;
  }

  static async couponNoUses(axios, company, branchOffice) {
    const response = await axios.post(
      '/graphql/',
      `query {
        couponNoUses (companyId: ${company}, branchOfficeId: ${branchOffice}) {
          id
          isActive
          title
          expirationDate
          globalTotalUses
          globalUses
          assignedCoupon
          globalActives
          images {
            id
            url
          }
          initialDate
          dailyUses
          totalUses
          coupons{
            id
            title
          }
          company{
            id
            name
          }
          branchOffices{
            id
            name
          }
          couponsUses{
            id
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.couponNoUses;
  }
}
